import axios from "../../config/axiosConfig";
import {
  CREATE_VEHICLE_UPAD, DELETE_VEHICLE_UPAD,
  GET_VEHICLE_UPAD,
  VEHICLE_UPAD_REQUEST,
  VEHICLE_UPAD_REQUEST_FAILURE,
  UPDATE_VEHICLE_UPAD
} from "../types/vehicle-upad-types";

export const getVehicleUpad = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VEHICLE_UPAD_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/vehicle-upad/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_VEHICLE_UPAD, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createVehicleUpad = (vehicleUpad) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: VEHICLE_UPAD_REQUEST });
      const newVehicleUpad = {
        ...vehicleUpad
      };
      return axios.post("/vehicle-upad/add", newVehicleUpad,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_VEHICLE_UPAD, payload: response.data });
        } else {
          dispatch({
            type: VEHICLE_UPAD_REQUEST_FAILURE,
            error: "vehicle Attendance Monthly create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateVehicleUpad = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VEHICLE_UPAD_REQUEST });
      const { auth } = getState();
      return axios.put("/vehicle-upad/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_VEHICLE_UPAD,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: VEHICLE_UPAD_REQUEST_FAILURE,
            error: "vehicle Attendance Monthly update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteVehicleUpad = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: VEHICLE_UPAD_REQUEST });
      return axios.delete(`/vehicle-upad/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_VEHICLE_UPAD, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const addUpdateVehicleUpad = (data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VEHICLE_UPAD_REQUEST });
      const { auth } = getState();

      return axios.post(
        "/vehicle-upad/add-update",   // ✅ correct API
        data,
        {
          params: {
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          dispatch({
            type: CREATE_VEHICLE_UPAD,  // ✅ treat like create/update merge
            payload: response.data,
          });
        } else {
          dispatch({
            type: VEHICLE_UPAD_REQUEST_FAILURE,
            error: "Vehicle Upad add/update failed.",
          });
        }
        return response;
      })
      .catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
        throw error;
      });

    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_UPAD_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};